import { SearchTerm } from "./SearchTerm";

const AuditReportSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "auditSession.asUserLoginName",
        translationKey: "name"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "auditSession.asIp",
        translationKey: "ipAddress"
    },
    {
        heading: "Action",
        accessor: "action",
        searchOnName: "auditActionType.trnName",
        translationKey: "action"
    },
    {
        heading: "Audit Type",
        accessor: "type",
        searchOnName: "auditType.nameOriginal",
        translationKey: "auditType"
    },
    {
        heading: "Audit Sub Type",
        accessor: "subType",
        searchOnName: "auditSubType.nameOriginal",
        translationKey: "auditSubType"
    }
]

export default AuditReportSearch;
